export interface INormalizedObjects<T> {
	byId: { [id: string]: T };
	allIds: string[];
}
export const NormalizedObjectsFactory = () => {
	return {
		byId: {},
		allIds: []
	}
}